export default function AIOperator() {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">AI Operator Dashboard</h1>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-4">AI Models Status</h3>
          <div className="space-y-3">
            <div className="flex justify-between items-center">
              <span>Prediction Model</span>
              <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-sm">Active</span>
            </div>
            <div className="flex justify-between items-center">
              <span>Anomaly Detection</span>
              <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-sm">Active</span>
            </div>
            <div className="flex justify-between items-center">
              <span>Weather Correlation</span>
              <span className="px-2 py-1 bg-yellow-100 text-yellow-800 rounded-full text-sm">Training</span>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-semibold mb-4">Automated Operations</h3>
          <div className="space-y-3">
            <div className="flex justify-between">
              <span>Auto Optimization:</span>
              <span className="font-semibold text-green-600">Enabled</span>
            </div>
            <div className="flex justify-between">
              <span>Predictive Maintenance:</span>
              <span className="font-semibold text-green-600">Active</span>
            </div>
            <div className="flex justify-between">
              <span>Smart Alerts:</span>
              <span className="font-semibold text-blue-600">Running</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}